import React from "react"
import TaskTypeIcon from "../../../../../gd-components/icons/task-icon/task-icon-ui5"
import {FieldQuickFilterViewProps} from "../../../../render/quick-filter-view";
import {QUICK_FILTER_ALL_VALUES} from "../../../../../gd/const/quick-filter";

export default function FieldTaskType_QuickFilterView(props: FieldQuickFilterViewProps) {


    let icon    = null
    let label   = 'Unknown'

    switch (props.value) {
        case QUICK_FILTER_ALL_VALUES :
            label = 'All task types'
            break
        default:
            icon = <TaskTypeIcon className="icon m-r-10" taskTypeId={props.value} size="14"/>
            label = gd.session.taskTypes.get(props.value)!.name
            break
    }


    return (
        <div className="ui5-group-by-view">
            {icon}
            <div className="name">{label}</div>
        </div>
    )




}